export default __webpack_public_path__ + "static/media/graph-v4.0a3b7c30.png";